export type { CheckboxProps } from "@components/contracts/Checkbox.types";
export { CelebrationCheckbox } from "./Checkbox.adapter";
